import { render, staticRenderFns } from "./street-list.vue?vue&type=template&id=45b8cea2&scoped=true"
import script from "./street-list.vue?vue&type=script&lang=js"
export * from "./street-list.vue?vue&type=script&lang=js"
import style0 from "./street-list.vue?vue&type=style&index=0&id=45b8cea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8cea2",
  null
  
)

export default component.exports